export class TableHead {
  title: string;
  field?: string;
  sort?: boolean;
  isStatic?: boolean;
  class?: string;
  sortAs ?: string;
  isCheck ?: boolean;
}
